import React from "react";
import {File} from "features/model/types/homeWorkSchema";
import {NothingYetMessage} from "../../../../../personal-cabinet/nothing-yet-message/NothingYetMessage";


interface IFilesList {
    files: File[]
}

export const FilesList = ({files}: IFilesList) => {
    return (
        files && files.length > 0 ? (
                <ul className="attached-files-list">
                    {files.map((file, index) => (
                        <li key={index}>
                            <div className="file-name">
                                <a href={file.path} target="_blank" rel="noopener noreferrer">
                                    {file.fileName}
                                </a>
                            </div>
                            <span className="file-size">{file.fileSize}</span>
                        </li>
                    ))}
                </ul>
        ) : (
            <NothingYetMessage/>
        )
    );
};
